import {bankSvg as Icon__small__bankSvg} from '../Icon__small/Icon__small--bank.js'

export var bank = {
  name: 'bank',
  category: 'icon',
  colorable: true,
  svg: Icon__small__bankSvg,
};
